import { pairs as Pairs } from 'd3-array'
import * as THREE from 'three'
import groupBy from 'lodash/groupBy'
import mapValues from 'lodash/mapValues'
import orderBy from 'lodash/orderBy'
import find from 'lodash/find'

// import fenceLidar from "./Lidar/FenceData";
import { fenceMap } from './Lidar/FencesLidar'

import { toPoint } from '../../Utils/CustomPoint'

export const toFenceMap = ({ data }) => {
    let map = groupBy(data, 'venue_id')

    map = mapValues(map, (d) => ({
        venueId: d[0].venue_id,
        points: orderBy(d, 'angle').map(toPoint),
    }))

    return map
}

// const getFencePoints = (venueId) => {
//     const fences = fenceLidar.fenceMap[venueId]
//     const points = fences.map((d) => ({
//         venueId: d.venueId,
//         angle: d.angle,
//         x: d.x,
//         y: d.y,
//         z: d.z,
//         distance: d.distance,
//     }))

//     return points
// }

const toSegments = (points) => {
    const segments = []
    let segment = []
    let z = null

    points.forEach((p) => {
        if (p.z === z) {
            segment.push(p)
        } else {
            if (segment.length > 0) {
                segments.push(segment)
            }
            segment = [p]
            z = p.z
        }
    })
    if (segment.length > 0) {
        segments.push(segment)
    }

    return segments
}

const toCappedSegments = (segments) => {
    const copy = [...segments]

    const pairs = Pairs(copy)

    pairs.forEach((pair) => {
        const segment0 = pair[0]
        const segment1 = pair[1]
        const p = segment0[segment0.length - 1]
        const q = segment1[0]
        const x = 0.5 * (p.x + q.x)
        const y = 0.5 * (p.y + q.y)
        segment0.push({
            x,
            y,
            z: p.z,
        })
        segment1.unshift({
            x,
            y,
            z: q.z,
        })
    })

    return copy
}

const addFenceVerticesAndFaces = ({ geometry, points, vertexOffset = 0 }) => {
    const pointPairs = Pairs(points)

    points.forEach((p) => {
        geometry.vertices.push(
            new THREE.Vector3(p.x, p.y, p.z),
            new THREE.Vector3(p.x, p.y, 0)
        )
    })

    pointPairs.forEach((pair, i) => {
        const j = vertexOffset + 2 * i

        geometry.faces.push(
            new THREE.Face3(j, j + 1, j + 2),
            new THREE.Face3(j + 2, j + 1, j + 3)
        )
    })
}

export const toFenceGeometry = ({ venueId, squaredSegmentJoins = true }) => {
    let points = fenceMap[venueId]

    // If venue doesn't exist default to KC
    if (!points) {
        // eslint-disable-next-line prefer-destructuring
        points = fenceMap[7]
    }

    const distance = {
        lf: find(points, (d) => d.angle === -45).distance,
        rf: find(points, (d) => d.angle === 45).distance,
    }

    const segments = toSegments(points)
    const geometry = new THREE.Geometry()

    if (squaredSegmentJoins) {
        const cappedSegments = toCappedSegments(segments)
        let vertexOffset = 0

        cappedSegments.forEach((segment) => {
            addFenceVerticesAndFaces({
                geometry,
                points: segment,
                vertexOffset,
            })

            vertexOffset += 2 * segment.length
        })
    } else {
        const pointPairs = Pairs(points)

        // add vertices
        points.forEach((p) => {
            geometry.vertices.push(
                new THREE.Vector3(p.x, p.y, p.z),
                new THREE.Vector3(p.x, p.y, 0)
            )
        })

        // add faces – 2 faces for each point pair
        pointPairs.forEach((pair, i) => {
            const j = 2 * i

            geometry.faces.push(
                new THREE.Face3(j, j + 1, j + 2),
                new THREE.Face3(j + 2, j + 1, j + 3)
            )
        })
    }

    geometry.computeFaceNormals()
    geometry.computeFlatVertexNormals()
    geometry.computeBoundingBox()
    geometry.computeBoundingSphere()

    return {
        geometry: new THREE.BufferGeometry().fromGeometry(geometry),
        distance,
    }
}

export const toAllFencesGroup = () => {
    const g = new THREE.Group()

    return g
}
